import axiosClient from './axiosClient';
import { ISensorType } from '~/utils/interface/sensor';

const sensorApi = {
  getSensorTypes() {
    return axiosClient.get<ISensorType[]>('/api/sensor/sensor-types');
  },
};
export default sensorApi;
